var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready && this.tiers && this.tiers.length
    ? _c(
        "div",
        { staticClass: "shipping_bar", attrs: { id: _vm.id } },
        [
          _c("shipping_progress_bar", {
            attrs: {
              id: _vm.id,
              "cart-total": _vm.useOriginalTotal
                ? _vm.originalCartTotal
                : _vm.cartTotal,
              "current-tier": _vm.currentTier,
              "prev-tier": _vm.highestAchievedTier,
              shown: _vm.shown,
              delay: _vm.delay,
              "icon-type": _vm.iconType,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }